import React from 'react';
import { TableCell } from '@mui/material';

function normalizeCell(cell) {
	return cell && typeof cell === 'object' && Object.prototype.hasOwnProperty.call(cell, 'content')
		? cell
		: { content: cell };
}

export default function RenderRowCells({ row, rowId, renderRowCells }) {
	const cells = renderRowCells(row);
	const cellItems = Array.isArray(cells) ? cells : React.Children.toArray(cells);

	return cellItems.map((cell, index) => {
		if (React.isValidElement(cell)) {
			const key = cell.props?.cellKey || cell.key || `${rowId}-${index}`;
			// cloneElement keeps the original props/children intact and only adds the key.
			return React.cloneElement(cell, { key });
		}

		const cellConfig = normalizeCell(cell);

		return (
			<TableCell key={cellConfig.key || `${rowId}-${index}`} sx={cellConfig.sx}>
				{cellConfig.content}
			</TableCell>
		);
	});
}
